import React from 'react';
import PidDiagramShell, { PidPipe, PidPort } from './PidDiagramShell';
import { OlefinRoute } from '../../types';

/** 甲烷氧化偶联（OCO）P&ID 详细图：甲烷+O₂ 偶联反应 → 急冷压缩 → 乙烯分离（中试阶段） */
const media = {
  gas: { label: '甲烷 / 原料气', light: '#2e7d32', dark: '#81c784', width: 2.6 },
  oxy: { label: '氧气', light: '#d32f2f', dark: '#e57373', width: 2 },
  oil: { label: '反应产物 / 乙烯', light: '#ef6c00', dark: '#ffb74d', width: 2.6 },
  water: { label: '水 / 急冷水', light: '#1565c0', dark: '#64b5f6', width: 2 },
};

const devices = [
  { id: 'v101', kind: 'hDrum' as const, x: 60, y: 189, tag: 'V-101', name: '甲烷缓冲罐' },
  { id: 'mix101', kind: 'mixer' as const, x: 220, y: 225, tag: '', name: '' },
  { id: 'r101', kind: 'reactor' as const, x: 320, y: 128, tag: 'R-101', name: 'OCO反应器', note: '催化偶联' },
  { id: 't101', kind: 'column' as const, x: 500, y: 101, tag: 'T-101', name: '急冷塔' },
  { id: 'c101', kind: 'compressor' as const, x: 660, y: 193, tag: 'C-101', name: '反应气压缩机' },
  { id: 't102', kind: 'column' as const, x: 810, y: 101, tag: 'T-102', name: '乙烯分离塔' },
];

const ports: PidPort[] = [
  { id: 'p-feed', label: '甲烷', medium: 'gas', x: 0, y: 224, direction: 'in' as const },
  { id: 'p-o2', label: '氧气', medium: 'oxy', x: 150, y: 330, direction: 'in' as const },
  { id: 'p-ethylene', label: '乙烯', medium: 'oil', x: 990, y: 611, direction: 'out' as const },
  { id: 'p-tail', label: '未反应甲烷循环', medium: 'gas', x: 900, y: 52, direction: 'out' as const },
];

const pipes: PidPipe[] = [
  { id: 's01', from: 'p-feed', fromSide: 'right', to: 'v101', toSide: 'left', medium: 'gas' },
  { id: 's02', from: 'v101', fromSide: 'right', to: 'mix101', toSide: 'left', medium: 'gas' },
  { id: 's03', from: 'p-o2', fromSide: 'right', to: 'mix101', toSide: 'bottom', medium: 'oxy' },
  { id: 's04', from: 'mix101', fromSide: 'right', to: 'r101', toSide: 'left', medium: 'gas' },
  { id: 's05', from: 'r101', fromSide: 'right', to: 't101', toSide: 'left', medium: 'oil' },
  { id: 's06', from: 't101', fromSide: 'right', to: 'c101', toSide: 'left', medium: 'oil' },
  { id: 's07', from: 'c101', fromSide: 'right', to: 't102', toSide: 'left', medium: 'oil' },
  { id: 's08', from: 't102', fromSide: 'bottom', to: 'p-ethylene', toSide: 'left', medium: 'oil' },
  { id: 's09', from: 't102', fromSide: 'top', to: 'p-tail', toSide: 'left', medium: 'gas' },
];

const OcoDiagram: React.FC<{ route: OlefinRoute }> = ({ route }) => (
  <PidDiagramShell
    routeName={route.name}
    title="OCO 装置详细流程（中试）"
    subtitle="甲烷与氧气催化氧化偶联（硅铝酸盐催化剂）→ 急冷 → 压缩 → 乙烯分离，未反应甲烷循环，中试阶段工艺（设备形状按 P&ID 惯例，管线按介质分色）"
    media={media}
    devices={devices}
    ports={ports}
    pipes={pipes}
    feedstock={route.feedstock}
    products={[...route.products, ...(route.byproducts ?? [])]}
  />
);

export default OcoDiagram;
